module.exports = __webpack_public_path__ + "img/boat7.5f256b46.jpg";